'use strict';

angular.module('theme').component('discountMypageBanner', {
	bindings: {
	},
	templateUrl: 'component/discount-mypage-banner.html',
	controller: function($scope, $cookies, CustomerService) {
		var self = this;
		self.showBanner = false;

		var customer = CustomerService.get().then(function (customer) {
			self.customer = customer;
			self.currentLevel = customer.loyaltyClub.level;
			self.points = customer.loyaltyPoints;
			self.kronor = Math.floor((customer.loyaltyPoints / 50));

			console.log('NumberOfFreeShopArticles:', customer.NumberOfFreeShopArticles);

			// Spara i localStorage
			var numberOfFree = customer.NumberOfFreeShopArticles;
			// var numberOfFree = 0;

			// Logga värdet för att kontrollera innan vi sparar det i localStorage
			console.log('Sparar NumberOfFreeShopArticles:', numberOfFree);

			// Sätt cookien om värdet är 1 eller större
			if (numberOfFree >= 1) {  // Ändra här för att spara även för värdet 1
				document.cookie = "NumberOfFreeShopArticles=" + numberOfFree + "; path=/; max-age=86400";
				console.log('Cookie satt: ', document.cookie);
			}

			self.showBanner = true;
		});

		console.log(self.customer);

		if ($cookies.get('campaign-code-discount') && self.code && typeof self.code === 'string' && self.code !== '') {
			var data = JSON.parse($cookies.get('campaign-code-discount'));

			if (self.code !== data.code) return;

			self.description = decodeURIComponent(data.description);
			self.amount = data.amount;

			$cookies.put('campaign-code', self.code, {
				path: '/',
				expires: moment().add(1, 'month').toDate()
			});

			self.showBanner = true;
		}
	}
});
